import { TFunction } from 'i18next';

import { Difficulty1Icon, Difficulty2Icon, Difficulty3Icon } from '@udacity/chakra-uds-icons';

export const DIFFICULTY_OPTIONS = {
  discovery: 'discovery',
  fluency: 'fluency',
  beginner: 'beginner',
  intermediate: 'intermediate',
  advanced: 'advanced',
} as const;

export function getDifficultyData(t: TFunction, difficulty: keyof typeof DIFFICULTY_OPTIONS | string) {
  return {
    icon: difficultyIconMap.get(difficulty),
    label: t(`program.difficulty.${difficulty}`),
  };
}

export function getDifficultyDataForPdf(t: TFunction, difficulty: keyof typeof DIFFICULTY_OPTIONS | string) {
  return {
    imageUrl: difficultyIconMapForPdf.get(difficulty),
    label: t(`program.difficulty.${difficulty}`),
  };
}

const keyMap = new Map<string, string>();
keyMap.set('beginner', 'program.difficulty.beginner');
keyMap.set('discovery', 'program.difficulty.discovery');
keyMap.set('fluency', 'program.difficulty.fluency');
keyMap.set('intermediate', 'program.difficulty.intermediate');
keyMap.set('advanced', 'program.difficulty.advanced');

export function getDifficultyLevel(difficultyLevel: string | string[] | null | undefined, t: TFunction): string | null {
  if (!difficultyLevel) return null;

  if (Array.isArray(difficultyLevel)) {
    return null;
  }

  const levelKey = difficultyLevel.toLowerCase();
  const i18nKey = keyMap.get(levelKey);
  return i18nKey ? t(i18nKey) : difficultyLevel;
}

const difficultyIconMap = new Map<keyof typeof DIFFICULTY_OPTIONS | string, React.ReactNode>();
difficultyIconMap.set(DIFFICULTY_OPTIONS.discovery, <Difficulty1Icon h='16px' w='16px' />);
difficultyIconMap.set(DIFFICULTY_OPTIONS.fluency, <Difficulty1Icon h='16px' w='16px' />);
difficultyIconMap.set(DIFFICULTY_OPTIONS.beginner, <Difficulty1Icon h='16px' w='16px' />);
difficultyIconMap.set(DIFFICULTY_OPTIONS.intermediate, <Difficulty2Icon h='16px' w='16px' />);
difficultyIconMap.set(DIFFICULTY_OPTIONS.advanced, <Difficulty3Icon h='16px' w='16px' />);

const difficultyIconMapForPdf = new Map<keyof typeof DIFFICULTY_OPTIONS | string, string>();
difficultyIconMapForPdf.set(DIFFICULTY_OPTIONS.discovery, '/images/difficulty_1.png');
difficultyIconMapForPdf.set(DIFFICULTY_OPTIONS.fluency, '/images/difficulty_1.png');
difficultyIconMapForPdf.set(DIFFICULTY_OPTIONS.beginner, '/images/difficulty_1.png');
difficultyIconMapForPdf.set(DIFFICULTY_OPTIONS.intermediate, '/images/difficulty_2.png');
difficultyIconMapForPdf.set(DIFFICULTY_OPTIONS.advanced, '/images/difficulty_3.png');
